import type { IMasterDataReasonCodeMappingRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataReasonCodeMappingsDTO } from "@src/domain/dto/masterData";

export class GetMasterDataReasonCodeMappingsUseCase {
  private readonly repository: IMasterDataReasonCodeMappingRepository;

  constructor(repository: IMasterDataReasonCodeMappingRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataReasonCodeMappingsDTO) {
    return this.repository.getReasonCodeMappings(params);
  }
}
